import { Body_add_your_food_api_v1_meals_your_food_post } from "@/clients/models/Body_add_your_food_api_v1_meals_your_food_post";
import z from "zod";

export const AddRecipeSchema = z.object({
  recipeName: z.string(),
  mealTime: z.union([
    z.enum(Body_add_your_food_api_v1_meals_your_food_post.meal_time),
    z.literal(""),
  ]),
  portionSize: z.number().min(1).max(999),
  // Prevent whitespace-only ingredient input while validating on submit.
  ingredients: z
    .string()
    .refine(
      (value) => value.trim().length > 0,
      "Please add at least one ingredient before saving your recipe.",
    ),
  instructions: z.string(),
});
